import { gql } from '@apollo/client';

export const CREATE_ADDRESS = gql`
    mutation createAddress(
        $firstname: String!
        $lastname: String!
        $street: [String]
        $telephone: String!
        $postcode: String!
        $city: String!
        $company: String
        $vat_id: String
        $country_code: CountryCodeEnum
        $default_billing: Boolean
        $default_shipping: Boolean
    ) {
        createCustomerAddress(
            input: {
                country_code: $country_code
                street: $street
                telephone: $telephone
                postcode: $postcode
                city: $city
                firstname: $firstname
                lastname: $lastname
                company: $company
                vat_id: $vat_id
                default_shipping: $default_shipping
                default_billing: $default_billing
            }
        ) {
            id
            country_code
            region {
                region
                region_code
            }
            street
            telephone
            postcode
            city
            company
            vat_id
            default_shipping
            default_billing
        }
    }
`;
export const UPDATE_ADDRESS = gql`
    mutation updateAddress(
        $id: Int!
        $firstname: String!
        $lastname: String!
        $street: [String]
        $telephone: String!
        $postcode: String!
        $city: String!
        $company: String
        $vat_id: String
        $country_code: CountryCodeEnum
        $default_billing: Boolean
        $default_shipping: Boolean
    ) {
        updateCustomerAddress(
            id: $id
            input: {
                country_code: $country_code
                street: $street
                telephone: $telephone
                postcode: $postcode
                city: $city
                firstname: $firstname
                lastname: $lastname
                company: $company
                vat_id: $vat_id
                default_shipping: $default_shipping
                default_billing: $default_billing
            }
        ) {
            id
            country_code
            region {
                region
                region_code
            }
            street
            telephone
            postcode
            city
            company
            vat_id
            default_shipping
            default_billing
        }
    }
`;

export const DELETE_ADDRESS = gql`
    mutation deleteCustomerAddress($id: Int!) {
        deleteCustomerAddress(id: $id)
    }
`;

export const EXPORT_STATUS = gql`
    query exportStatus{
        exportStatus
    }
`

export const SESSION_ID = gql`
    query tokenConverter{
        tokenConverter
    }
`

export const COUNTRIES = gql`
    query{
        countries{
            full_name_locale
            id
        }
    }
`

export const COUNTRY_BY_ID = gql`
    query country($id:String){
        country(id:$id) {
            full_name_locale
        }
    }
`